"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const react_1 = __importDefault(require("react"));
const Header_1 = __importDefault(require("./Header"));
const Footer_1 = __importDefault(require("./Footer"));
class Container extends react_1.default.Component {
    render() {
        return (react_1.default.createElement("div", { className: "app" },
            react_1.default.createElement("div", { className: "app-header" },
                react_1.default.createElement(Header_1.default, null)),
            react_1.default.createElement("main", { className: "app-content" }, this.props.children),
            react_1.default.createElement("div", { className: "app-footer" },
                react_1.default.createElement(Footer_1.default, null))));
    }
}
exports.Container = Container;
//# sourceMappingURL=Container.js.map